<template>
  <b-card>
    <div class="d-flex justify-content-between align-items-center w-100 mb-1">
      <h3>قاعات المنارة</h3>
      <div>
        <b-button variant="primary" @click="onAdd()">
          <feather-icon icon="userIcon" /> إضافة </b-button
        >
      </div>
    </div>

    <data-table ref="estatesTable" :pagination="false" :fields="fields" ep="/halls">
      <template #cell(hall_type)="row" >
        <div>
          {{row.item.hall_type=='T' ? 'تدريبة': row.item.hall_type=='W' ?'مساحة عمل':  row.item.hall_type=='M' ?'مكتب':''}}
        </div>
      </template>
      <template #cell(actions)="row">
        <b-dropdown
          variant="link"
          no-caret
          :right="$store.state.appConfig.isRTL"
        >
          <template #button-content>
            <feather-icon
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle text-body"
            />
          </template>

          <b-dropdown-item @click="onUpdateClicked(row.item)">
            <feather-icon icon="EditIcon" />
            <span class="align-middle ml-50">تعديل</span>
          </b-dropdown-item>

          <b-dropdown-item @click="onDelete(row.item)">
            <feather-icon icon="Trash2Icon" />
            <span class="align-middle ml-50">حذف</span>
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </data-table>
    <form-modal
      ref="estateModalHalls"
      :formSchema="estatesFormSchema"
      title="إضافة"
      v-model="activModel"
      :loading="loading"
      @confirm="onModalConfirmed"
    >
    </form-modal>
  </b-card>
</template>
    <script>
import {
  BCard,
  BButton,
  BRow,
  BCol,
  VBToggle,
  VBTooltip,
  BCollapse,
  BImg,
  BMediaBody,
  BMedia,
  BMediaAside,
  BAvatar,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import DataTable from "@/components/data-table/index";
import FormInput from "@/components/form-input/index";
import Ripple from "vue-ripple-directive";
import FormModal from "@/components/FormModal.vue";
import FormFile from "@/components/form-file/index.vue";
import { mapActions, mapGetters } from "vuex";
import { BCarousel, BCarouselSlide } from "bootstrap-vue";
import { typesHalls,floors } from "@/utils/items-enam";
export default {
  components: {
    BCard,
    DataTable,
    BButton,
    FormInput,
    BRow,
    BCol,
    FormModal,
    FormFile,
    BCollapse,
    VBTooltip,
    VBToggle,
    BImg,
    BCarousel,
    BCarouselSlide,
    BMediaAside,
    BMediaBody,
    BMedia,
    BAvatar,
    BDropdown,
    BDropdownItem,
  },
  directives: {
    Ripple,
  },
  data: () => {
    return {
      imageSlide: [],
      staticImages: [],
      fields: [
        { key: "floor", label: "الطابق" },
        { key: "code", label: "رقم القاعة", sortable: true },
        { key: "hall_type", label: "نوع القاعة" },
        { key: "capacity", label: "سعة القاعة" },
        { key: "ip_camera", label: "ip الكاميرا" },
        { key: "actions", label: "" },
      ],
      activModel:false,
      estatesFormSchema: {
        code: { 
          component: "FormInput",
          key: "code",
          attrs: {
            id: "code",
            label: "رقم القاعة",
            rules: "required",
          },
        },
        capacity: {
          component: "FormMask",
          key: "capacity",
          attrs: {
            label: "سعة القاعة",
            options: "number",
            rules: "required",
            dir: "ltr",
            placeholder: "",
          },
        },
        floor: {
          component: "FormSelect",
          key: "floor",
          attrs: {
            id: "floor",
            label: "الطابق",
            rules: "required",
            reduce: (el) => el.value,
            options: floors,
          },
        },
        hall_type: {
          component: "FormSelect",
          key: "hall_type",
          attrs: {
            id: "hall_type",
            label: "نوع القاعة",
            rules: "required",
            reduce: (el) => el.value,
            options: typesHalls,
          },
        },
        ip_camera:{
          component: "FormInput",
          key: "ip_camera",
          attrs: {
            id:'ip_camera',
            label: "ip الكميرا",
            // options: "number",
            rules: "required",
            dir: "rtl",
            placeholder: "255.255.255.255",
          },
        }
      },
      utils: {
        status: "",
      },
      filter: "",
    };
  },
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
  },
  methods: {
    ...mapActions("settings/manageHalls", [
      "updateHalls",
      "createHalls",
      "deleteHalls",
    ]),

    onAdd() {
      this.$refs.estateModalHalls.init({});
      this.activModel = true;
    },

    onUpdateClicked(form) {
      var toUpdate = {
        id: form.id,
        code: form.code,
        capacity: form.capacity,
        floor: form.floor,
        hall_type: form.hall_type,
        ip_camera: form.ip_camera,
      };
      this.$refs.estateModalHalls.init(toUpdate);
      this.activModel = true;
    },

    onDelete(item) {
      // console.log(id)
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف النشاط", {
          title: "تأكيد حذف النشاط",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value)
            this.deleteHalls({ id: item.id }).then(() => {
              this.$refs.estatesTable.refreshTable();
            });
        });
    },

    onModalConfirmed(form) {
      if (form.id) {
        this.updateHalls({ id: form.id, data: form }).then(() => {
          this.$refs.estatesTable.refreshTable();
          this.activModel = false;
        });
      } else
        this.createHalls({ data: form  }).then(() => {
          this.$refs.estatesTable.refreshTable();
          this.activModel = false;
        });
    },
  },

  computed: {
    ...mapGetters("settings/manageHalls", ["loading"]),
  },
};
</script>
  <style lang="scss" >
.top-m {
  padding-top: 7px;
}
</style>